import { useMutation } from '@tanstack/react-query'
import { generateVndlyTimesheet } from 'api/vndly/generateTimesheet'
import { format } from 'date-fns'
import fileDownload from 'js-file-download'

type GenerateVndlyTimesheetMutationParams = Parameters<
  typeof generateVndlyTimesheet
>[0]

function getVndlyTimesheetFilename(startDate: Date, endDate: Date) {
  const startLabel = format(startDate, 'MMM-dd')
  const endLabel = format(endDate, 'MMM-dd')

  return `vndly_timesheet_${startLabel}_${endLabel}.csv`
}

export function useGenerateVndlyTimesheetMutation(
  params: GenerateVndlyTimesheetMutationParams
) {
  return useMutation({
    mutationFn: async () => {
      const csv = await generateVndlyTimesheet(params)
      const filename = getVndlyTimesheetFilename(
        params.startDate,
        params.endDate
      )
      fileDownload(csv, filename)
    },
  })
}
